export enum InputSize {
  small = 'small',
  large = 'large',
}
